import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {goBack, push} from "../ducks/duck-router";
import {removeModalWindow, removeModalWindowAtIndexes} from "../ducks/duck-screen";

import Phone from "./phone";

class PhoneContainer extends React.Component{
	componentDidMount(){
		console.log("Listening for Install prompt");
		window.addEventListener('beforeinstallprompt',e=>{
			// For older browsers
			e.preventDefault();
			console.log("Install Prompt fired");
			this.installPrompt = e;
			// See if the app is already installed, in that case, do nothing
			if((window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true){
				return false;
			}
			// Set the state variable to make button visible
			this.setState({
				installButton:true
			})
		})
	}

	render(){
		return <Phone {...this.props} />;
	}
}

PhoneContainer.propTypes = {
	screen: PropTypes.string.isRequired,
	uid: PropTypes.string.isRequired,

	loadingList: PropTypes.array.isRequired,
	modalList: PropTypes.array.isRequired,
	toastList: PropTypes.array.isRequired,

	currentLevel: PropTypes.object.isRequired,

	push: PropTypes.func.isRequired,
	goBack: PropTypes.func.isRequired,
	removeModalWindow: PropTypes.func.isRequired,
	removeModalWindowAtIndexes: PropTypes.func.isRequired
};

function mapStateToProps(state) {
	return {
		screen: state.screenReducer.screen,
		loadingList: state.screenReducer.loadingList,
		modalList: state.screenReducer.modalList,
		toastList: state.screenReducer.toastList,
		uid: state.userReducer.uid,
		currentLevel: state.gameReducer.currentLevel
	};
}

export default connect(mapStateToProps, {
	push,
	goBack,
	removeModalWindow,
	removeModalWindowAtIndexes
})(PhoneContainer);
